import Head from 'next/head';

import { CSP_LOGGED_IN_HEADERS } from 'src/consts/headers';
import { CAPSULE_ENVIRONMENT } from 'src/landing-pages/consts';

export const OverrideContentSecurityPolicy = () => {
  if (!(CAPSULE_ENVIRONMENT in CSP_LOGGED_IN_HEADERS)) {
    return null;
  }

  return (
    <Head>
      <meta httpEquiv="Content-Security-Policy" content={CSP_LOGGED_IN_HEADERS[CAPSULE_ENVIRONMENT]} />
    </Head>
  );
};
